/**
 * Vue路由配置文件
 * 定义应用的所有路由规则和配置
 */

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 重写路由push/replace方法，添加错误捕获
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

/**
 * 路由表配置
 * path: 路由路径
 * name: 路由名称
 * component: 路由组件(使用懒加载)
 * redirect: 重定向路径
 * children: 嵌套路由
 */
const routes = [
  // 登录路由
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login.vue')
  },
  // 主路由，包含嵌套子路由
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'), // 主布局组件
    redirect: '/activation', // 默认重定向到activation
    children: [
      // 子路由activation
      {
        path: 'activation',
        name: 'activation',
        component: () => import('../views/login/Activation.vue')
      },
      // 漏洞列表页面路由
      {
        path: 'vulnerability',
        name: 'vulnerability',
        component: () => import('../views/knowledge/vulnerability.vue')
      },
      // 漏洞详情页面路由
      {
        path: 'vulnerabilityDetails',
        name: 'vulnerabilityDetails',
        component: () => import('../views/knowledge/vulnerabilityDetails.vue')
      },
      // 投毒列表页面路由
      {
        path: 'poisoning',
        name: 'poisoning',
        component: () => import('../views/poisoning/Poisoning.vue')
      },
       // 投毒详情页面路由
      {
        path: 'poisoningDetails/:id',
        name: 'poisoningDetails',
        component: () => import('../views/poisoning/poisoningDetails.vue')
      }
    ]
  },
  // 搜索路由
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/Home.vue'), // 复用主布局组件
    redirect: '/vulnerability' // 重定向到vulnerability
  }
]

// 创建路由实例
const router = new Router({
  mode: 'history', // 使用HTML5 History模式
  base: process.env.BASE_URL, // 基础路径
  routes // 路由表
})

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  // 确保axios baseURL配置正确
  if (window.axios && window.axios.defaults && window.axios.defaults.baseURL) {
    const expectedBaseURL = window.$ipurl || 'http://192.168.101.50:9002/v1';
    if (window.axios.defaults.baseURL !== expectedBaseURL) {
      console.warn('路由守卫检测到baseURL不匹配，重新设置:', {
        current: window.axios.defaults.baseURL,
        expected: expectedBaseURL
      });
      window.axios.defaults.baseURL = expectedBaseURL;
    }
  }
  
  // 如果跳转的目标路由不是vulnerability或vulnerabilityDetails
  if (to.name !== 'vulnerability' && to.name !== 'vulnerabilityDetails') {
    // 清除筛选条件缓存
    sessionStorage.removeItem('vul_sortOrder');
    sessionStorage.removeItem('vul_dateRange');
    sessionStorage.removeItem('vul_severityFilter');
    sessionStorage.removeItem('vul_statusFilter');
    sessionStorage.removeItem('vul_tagFilter');
    sessionStorage.removeItem('vul_languageFilter');
  }
  next();
})

export default router
